module.exports = __webpack_public_path__ + "static/media/giphy.4a4b5c7e.gif";